//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('selectEquipmentPu', {
//        templateUrl: 'views/components/views/selectEquipmentPu/selectEquipmentPu.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'selectEquipmentPuService', function ($stateParams, selectEquipmentPuService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let webPageName = $stateParams.webpagename;
//            let operationId = $stateParams.operation_id;

//            vm.model = {
//                itemsListEquipmentPus: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSelectEquipmentPus() {
//                vm.model.itemsListEquipmentPus = await selectEquipmentPuService.listSelectEquipmentPus({
//                    webpagename: webPageName,
//                    operation_id: operationId
//                });
//            }

//		    // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region SAVE & GO TO PREVIOUS FUNCTION

//            vm.goBackToPrevious = function (item) {
//                selectEquipmentPuService.saveItem({
//                    equipment_id: item.item_id,
//                    webpagename: webPageName
//                });
//            }

//		    // #endregion SAVE & GO TO PREVIOUS FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSelectEquipmentPus();
//            }

//		    // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
